import {BaseService} from "../../base.service";
import {HttpService} from "../../http.service";
import {environment} from "../../../environments/environment";
import {Yearweek} from "../../models/yearweek";
import {Injectable} from "@angular/core";
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';

@Injectable()
export class MenuService extends BaseService
{
    private http: HttpService;
    private api: string;

    constructor(http: HttpService)
    {
        super();

        this.http = http;
        this.api = environment.api_url;
    }

    public getYearweek(): Promise<Yearweek>
    {
        return this.http
            .get(this.api + 'yearweek')
            .toPromise()
            .then(response => response.json() as Yearweek)
            .catch();
    }
}


// WEBPACK FOOTER //
// ./src/app/menu/service/menu.service.ts